module.exports = __webpack_public_path__ + "static/dallas-boyer-terminal-screenshot-banner-dimmed.fd08f0e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/config/img/dallas-boyer-terminal-screenshot-banner-dimmed.jpg
// module id = 196
// module chunks = 35783957827783 70144966829960 114276838955818 263791100135453